// ##### 25-04-30 Komarov
import { uniLog } from '../../../server/helpers/uniLog';
import { SET_DEVICE_TYPE } from '../constants';
export const setDeviceType = deviceType => async dispatch => {
  // ##### 25-04-30 Komarov
  uniLog('src/Redux/actions/setDeviceType.js:deviceType', deviceType);
  dispatch({
    type: SET_DEVICE_TYPE,
    payload: deviceType,
  });
};
